import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    divider: {
      margin: theme.spacing(2, -1),
    },
    fullAnnouncement: {
      height: '100%',
      '&:before': {
        height: 0,
      },
    },
    dialogContent: {
      paddingTop: 0,
      paddingBottom: theme.spacing(3),
    },
  };
};
